import { ChangePasswordFormData } from 'app/api/auth';

export const inititalValues: ChangePasswordFormData = {
  oldPassword: '',
  newPassword: '',
  confirmPassword: '',
};
